export default [
  {
    path: "/users",
    name: "UsersandGroups",
    component: () => import("@/views/3pl/Users/Index"),
  },
  {
    path: "/users/addUser",
    name: "AddNewUser",
    component: () => import("@/views/3pl/Users/AddUser"),
  },
  {
    path: "/users/editUser/:id",
    name: "EditNewUser",
    component: () => import("@/views/3pl/Users/EditUser"),
  },
  {
    path: "/users/addGroup",
    name: "AddNewGroup",
    component: () => import("@/views/3pl/Users/AddGroup"),
  },
 
];
